import { getApiBaseUrl } from '../../../../common/constants/constants';
import { initGA } from '../../../initGA';
import { http } from '../../../services';
import { saveToken } from '../../../services/http/storage';

const isElectron = !!window.require;

export async function logIn(username: string, password: string, captchaToken: string) {
  const googleClientId = await initGA();

  const requestBody = JSON.stringify({
    fromApp: isElectron,
    googleClientId,
    password,
    username,
    captchaToken,
  });

  const loggedInAccount = await http(`${getApiBaseUrl()}/user/sign-in`, {
    method: 'POST',
    body: requestBody,
  });

  saveToken(loggedInAccount?.body?.token, 'logIn');

  await initGA();

  return loggedInAccount;
}
